var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-link"
  }, [_vm.textContent || _vm.href ? _c('el-link', _vm._g(_vm._b({
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    }
  }, 'el-link', _vm.$attrs, false), _vm.$listeners), [_vm.iconPosition === 'left' && _vm.icon ? _c('i', {
    class: [_vm.icon, 'm-r-2']
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.textContent || _vm.href) + " "), _vm.iconPosition === 'right' && _vm.icon ? _c('i', {
    class: [_vm.icon, 'm-l-2']
  }) : _vm._e()]) : _vm._e(), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };